
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.343","height":"14.687"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"arrow-right (9)"}},[_c('path',{attrs:{"data-name":"Path 31495","d":"M6.929 1.414L1 7.343l5.929 5.929","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])
          )
        }
      }
    